/**
 * 创建自动下载任务弹窗
 */

import {Button, Form, message, Modal, Select} from "antd";
import React, {useEffect, useRef, useState} from "react";
import DatePicker from "@/components/datePicker";
import {createJt808PlaybackTask} from "@/service/jtDevicePlayback";
import dayjs from "dayjs";
import {useUserCateIdArr} from "@/utils/ownHooks";
import {carListRequest} from "@/service/carManage";
import _ from "lodash";
import axios from "axios";

const {RangePicker} = DatePicker;
const TaskFilterModal = (prop: any) => {
  const {onCancel, open, selectChannelData, selectDeviceChannelData,carId} = prop;
  // const cateIdArr = useUserCateIdArr();
  const [form] = Form.useForm();
  const [isPlateLoading, setIsPlateLoading] = useState<boolean>(false);
  const requestController = useRef<any>(null);
  const [allChannelOnCurrentCar, setAllChannelOnCurrentCar] = useState<any[]>(selectChannelData||[]);

  const getAutoDownloadTaskQueryParams = () => {
    const values = form.getFieldsValue();
    const {channelNo, time} = values;

    const beginTime = dayjs(time[0]).format("YYYY-MM-DD HH:mm:ss");
    const endTime = dayjs(time[1]).format("YYYY-MM-DD HH:mm:ss");

    return {
      beginTime, endTime, channel: channelNo,
      carId,
    }
  }
  const onFinish = async () => {
    const isValid = await form.validateFields();
    if (!isValid) {
      return;
    }

    const params = getAutoDownloadTaskQueryParams();
    try {
      // 获取所有需要发送的通道
      const channels = params.channel;
      let successCount = 0;
      let failCount = 0;

      // 串行发送请求，而不是并行
      for (let i = 0; i < channels.length; i++) {
        const channel = channels[i];
        const _params = {
          ...params,
          channel,
        };

        try {
          const res = await createJt808PlaybackTask(_params);
          if (res.data?.code === 0) {
            successCount++;
          } else {
            failCount++;
          }
        } catch (error) {
          console.error(`通道 ${channel} 创建任务失败:`, error);
          failCount++;
        }
      }

      // 所有请求完成后执行回调
      if (failCount === 0 && successCount > 0) {
        message.success(`成功创建 ${successCount} 个视频自动下载任务`);
        onCancel(); // 成功后关闭弹窗
      } else if (successCount > 0) {
        message.warning(`成功创建 ${successCount} 个任务，${failCount} 个任务创建失败`);
        onCancel(); // 部分成功也关闭弹窗
      } else {
        message.error("创建视频自动下载任务全部失败");
      }
    } catch (error) {
      console.error("创建视频自动下载任务失败", error);
      message.error("创建视频自动下载任务失败");
    }


  };
  const [plateNumberOptions, setPlateNumberOptions] = useState<any[]>([]);

  // const _handlePlateNumberSearch = async (val: string) => {
  //   setIsPlateLoading(true);
  //   const params = {
  //     page: 1,
  //     limit: 100,
  //     cate_id: cateIdArr,
  //   } as any;

  //   const plateNumber = (val || '').trim();
  //   if (plateNumber) {
  //     params.plateNumber = plateNumber;
  //   }
  //   try {
  //     // 取消上一个请求
  //     if (requestController.current) {
  //       requestController.current.cancel();
  //     }

  //     // 创建一个新的请求控制器
  //     const CancelToken = axios.CancelToken;
  //     const source = CancelToken.source();
  //     requestController.current = source;

  //     const res = await carListRequest({...params, cancelToken: source.token});
  //     const resData = res?.data?.data as any[] || [];
  //     setPlateNumberOptions(
  //       resData.map(
  //         (item: any) => ({
  //           label: item.plate_number,
  //           value: item.carId,
  //         }))
  //     );
  //   } catch (error) {
  //     setPlateNumberOptions([]);
  //       console.error("获取车牌号列表失败", error);
  //   }finally {
  //     setIsPlateLoading(false);
  //   }
  // }

  // const debounceHandlePlateNumberSearch = _.debounce(_handlePlateNumberSearch, 50);

  // useEffect(() => {
  //   _handlePlateNumberSearch('');
  // }, []);

  useEffect(() => {
    // 后续添加一个根据车辆信息来过滤通道的功能
    setAllChannelOnCurrentCar(selectChannelData || []);
  }, [selectChannelData]);

  return <Modal onCancel={onCancel} open={open} title="创建自动下载任务" footer={null}>
    <Form onFinish={onFinish} form={form}>
    
      <Form.Item label="时间范围" name="time"
                 rules={[
                   {required: true, message: "请选择时间范围"},
                   {
                     validator: (_, value) => {
                       if (!value || !value[0] || !value[1]) {
                         return Promise.resolve();
                       }

                       const startTime = value[0];
                       const endTime = value[1];
                       const diffInMinutes = endTime.diff(startTime, 'minute');

                       if (diffInMinutes > 30) {
                         return Promise.reject(new Error('时间范围不能超过30分钟'));
                       }

                       return Promise.resolve();
                     }
                   }
                 ]}>
        <RangePicker style={{width: "100%"}} showTime/>
      </Form.Item>
      <Form.Item
        label="视频通道"
        name="channelNo"
        rules={[{required: true, message: "请选择视频通道"}]}
      >
        <Select
          placeholder="请选择视频通道"
          options={allChannelOnCurrentCar}
          mode="multiple"
          showArrow
          maxTagCount="responsive"
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          创建自动下载任务
        </Button>
      </Form.Item>
    </Form>
  </Modal>
}

export {
  TaskFilterModal
}